import { Tracking } from './../../providers/tracking';
import { ToastMessage } from './../../providers/toast-message';
import { MyFirebaseList } from './../../providers/my-firebase-list';
import { ModelMetier } from './../../providers/model-metier';
import { CloudsPage } from './../clouds/clouds';
import { Component, ChangeDetectorRef, NgZone } from '@angular/core';
import { NavController, LoadingController, AlertController } from 'ionic-angular';
import { AuthData } from '../../providers/auth-data';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage { 

  
  constructor(public navCtrl: NavController, public loadingCtrl: LoadingController, public alertCtrl: AlertController,
                private zone: NgZone, private cd: ChangeDetectorRef,
                public toastMessage : ToastMessage, public tracking : Tracking,
                public authData: AuthData, public modelMetier: ModelMetier) {

console.log('Hello HomePage');

    this.clouds = this.modelMetier.clouds;
    this.licIds = this.modelMetier.licIds;


//@TODO subscribe change this.clouds, cd loaded ?
    // Init with the first
    this.clouds.loaded().then( ()=>{

      this.cloudId = this.clouds.elesFilterKeyValue[0].key;
      this.cloud = this.clouds.elesFilterKeyValue[0].value;

    });
  }
  

  ionViewDidEnter() {
    this.tracking.view(this);
  }


  clouds : MyFirebaseList;

  cloudId : string;
  cloud;

  licIds : MyFirebaseList;


  goToClouds() {
    // console.log("goToClouds");
    this.navCtrl.push(CloudsPage, {parent:this});
  }



  // 
  onViewAllLicIdsOfCloud() {

   console.log("onViewAllLicIdsOfCloud"); 

   this.tracking.event('Click', 'View all licIds of cloud', this.cloud.name, 0, false);

    // Clear licIds
    let strLicIds = '';
 
    if (this.cloud.licIds) {

      Object.keys( this.cloud.licIds ).forEach( (ele)=>{ 
        strLicIds += this.modelMetier.fbKey2licId( ele ) + ' ';
      });
    
    } 
    
    //console.log("licIds: "+ this.strLicIds);
    this.setStrLicIds(strLicIds);
  }

  // Import file, ou par D&D dans textArea
  importFile() {
    console.log("@TODO imlport file..."); 
  }



  // Raw input lic ids
  private strLicIds:string;

  // Split, filter lic id Array
  private tabLicId : string[];

  private info = '';
  // Tableau de variables ? Name:Value ?
  // Object Variables { name:value...}

  onChangeStrLicIds(event) {
      
    // get value from text area
    let newValue = event.target.value;
    this.setStrLicIds(newValue);
  }
  
  setStrLicIds(val:string) {
    this.strLicIds = val;
  
    // Get list licId
    this.tabLicId = this.modelMetier.getLicIds(this.strLicIds);
  }


  showInfo : boolean = true;


  // Return the cloud for licId
  getCloud(licId:string) {

    let ele = this.licIds.getEleId( this.modelMetier.licId2fbKey(licId) );
    if (!ele) return { name: this.clouds.elesFilterKeyValue[0].value.name, isConnected: false };

    let isConnected = (ele.cloudId != this.clouds.elesFilterKeyValue[0].key);
    return  { name: this.clouds.getEleId( ele.cloudId ).name,  isConnected: isConnected };
  }


  isConnected(licId)  {

    let ele = this.licIds.getEleId( this.modelMetier.licId2fbKey(licId) );
    if (!ele) return false;
    return true;
  }









  // Confirmation Alert
  // return Promise true if Ok, false if cancel
  confirmation():Promise<any> {

    return new Promise((resolve, reject) => {

      // si tres long ? btn inacessible...
      let nbMax = 15;
      let nbEle = 0;
      let msg = 'Are sure you want to attach: <ul>';
      this.tabLicId.forEach(element => {
        if (nbEle<nbMax) {
          msg = msg + '<li>"' + element + '"</li>';
          nbEle++;      
        }
      });
      if (nbEle>=nbMax) msg = msg + '<li>and more...</li>';
      msg = msg + '</ul>To cloud "' + this.cloud.name + '" ?'
          
      


      let alert = this.alertCtrl.create({
        title: 'Confirm action',
        subTitle: msg,
        buttons: [ 
          { text: 'Cancel', role: 'cancel', handler: () => { resolve(false); }  },
          { text: 'Ok', handler: () => { resolve(true); } }
        ]
      });
      
      alert.present();

    });
  
  }


  // Attach the licId to the cloud
  attachLicId(licId):Promise<any> {

    return this.modelMetier.attachLicIdToCloud(licId, this.info, this.cloudId);
  }

  attach() {


this.tracking.event('Click', 'Attach', this.strLicIds, 0, false);
    if (!this.strLicIds) return;

    // Get list licId
    this.tabLicId = this.modelMetier.getLicIds(this.strLicIds);

    // Message confirmation Ok, Cancel
    this.confirmation().then( (x) => {
            
      // Si Cancel, return
      // console.log('confirmation return ' + x);
      if (!x) return;


      let loader = this.loadingCtrl.create({
        content: "Please wait...",
      });
      loader.present();


      // Pour chaque licId tabLicId
      let promises = this.tabLicId.map( (licId)=> { 
        return this.attachLicId(licId);
      });

      
      return Promise.all(promises).then( ()=> { 

        // Refresh cloud
        this.cloud = this.clouds.getEleId( this.cloudId );

        loader.dismiss();
        this.toastMessage.success('All Attachement Ok');

      }).catch((err)=>{

        loader.dismiss();
        this.toastMessage.error(err);

      });

    })

    //@TODO
    // Process attachement licId au cloud
    // Get all result, and wait
    // Quand tous les result, display toast Ok  ou Erreur, avec validation

  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts